// removed by extract-text-webpack-plugin
module.exports = {"logo":"style__logo___2NE0g"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Main/Navbar/style.scss
// module id = 1025
// module chunks = 0